<template>
  <div>
    <div style="display: flex; flex-direction: column; gap: 10px">
      <div style="display: flex">
        <div style="width: 155px; font-size: 12px; font-weight: 600">
          {{ $t('base.start_time') }}
        </div>

        <div style="width: 30px;"></div>

        <div style="width: 155px; font-size: 12px; font-weight: 600">
          {{ $t('base.end_time') }}
        </div>
      </div>
      <draggable v-model="times" v-bind="dragOptions">
        <transition-group style="display: flex; flex-direction: column; gap: 10px">
          <div v-for="(time, index) in times" :key="`time_${index}`"
               style="display: flex; align-items: center; cursor: move">
            <div style="width: 155px;">
              <el-time-select
                v-model="time[`${prefix}start_time`]"
                class="full-w"
                size="mini"
                :clearable="false"
                :picker-options="{start: '00:00',step: '00:15',end: '23:45'}"
                :placeholder="$t('base.starting_time')"
                @change="m__emit_value()">
              </el-time-select>
            </div>
            <div style="width: 30px; text-align: center;">
              <div style="height: 1px; width: 5px; background-color: #000; margin: 0 auto"></div>
            </div>
            <div style="width: 155px;">
              <el-time-select
                v-model="time[`${prefix}end_time`]"
                class="full-w"
                size="mini"
                :clearable="false"
                :picker-options="{start: '00:00',step: '00:15',end: '24:00', minTime: time[`${prefix}start_time`]}"
                :placeholder="$t('base.ending_time')"
                @change="m__emit_value()">
              </el-time-select>
            </div>
            <div v-if="show_period" style="width: 185px; padding-left: 20px">
              <el-select v-model="time.period" size="mini">
                <el-option value="30" label="Chạy lại sau 30 phút"></el-option>
                <el-option value="60" label="Chạy lại sau 60 phút"></el-option>
              </el-select>
            </div>
            <div style="padding-left: 20px">
              <el-button v-if="times.length > 1" type="danger" size="mini" icon="el-icon-close"
                         @click="m__remove_time(index)"></el-button>
            </div>
          </div>
        </transition-group>
      </draggable>
      <div style="padding-left: 1px">
        <el-button v-if="times.length < max_items" type="text" size="mini" @click="m__add_time()">
          <strong style="color: #337ab7">
            <i class="el-icon-plus" style="color: #337ab7 !important; font-weight: bold !important;"></i>
            {{ $t('base.add') }} ({{ times.length }}/{{ max_items }})
          </strong>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: 'test',

  components: {
    draggable,
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },
    prefix: {
      type: String,
      default: ''
    },
    show_period: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      times: [],
      max_items: 10
    }
  },

  beforeMount() {
    this.m__gen_default()
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(new_value) {
        const clone = this.clone(new_value)

        for (const item of clone) {
          if (!item.period) item.period = '30'
        }

        this.times = clone
      }
    }
  },

  methods: {
    m__emit_value() {
      this.$emit('update:value', this.times)
    },

    m__add_time() {
      if (this.times.length >= this.max_items) {
        return
      }

      const new_time = {}
      new_time[`${this.prefix}start_time`] = ''
      new_time[`${this.prefix}end_time`] = ''
      new_time.period = '30'
      this.times.push(new_time)
    },

    m__remove_time(index) {
      this.times.splice(index, 1)
      this.m__emit_value()
    },

    m__gen_default() {
      if (!this.times || !this.times.length) {
        const new_time = {}
        new_time[`${this.prefix}start_time`] = ''
        new_time[`${this.prefix}end_time`] = ''
        new_time.period = '30'
        this.times.push(new_time)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_custom_time_picker.vue